module.exports = __webpack_public_path__ + "img/65.44687c03.jpg";